import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b003e4f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "data-inconsistency-last-update" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-clock-18px" }, null, -1));
import { computed } from 'vue';
// utils
import { formatLongDate } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyLastUpdate',
    props: {
        lastUpdate: {}
    },
    setup(__props) {
        const props = __props;
        // lib
        const [date, hour] = props.lastUpdate.split(' ');
        const formattedDate = computed(() => {
            return formatLongDate(date);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("p", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('integrations.data-inconsistency.last-update', { date: formattedDate.value, hour: _unref(hour) })), 1)
            ]));
        };
    }
});
